// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var CampaignsDataField$ReactHooksTemplate = require("../general_settings/campaignsDataField.res.js");
var CampaignDataFieldsForm$ReactHooksTemplate = require("./campaignDataFieldsForm.res.js");

var initialState = {
  campaignDataFields: /* [] */0,
  deletedCampaignDataFields: /* [] */0
};

function CampaignDataFieldPage(props) {
  var campaignId = props.campaignId;
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var fetchCampaignDataFields = function (param) {
    var url = "/api/v1/campaigns/" + campaignId + "/campaign_data_fields";
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Json_decode.field("campaigns_data_field", (function (param) {
                                    return Json_decode.list(CampaignsDataField$ReactHooksTemplate.decode, param);
                                  }), json));
                }), Http$ReactHooksTemplate.fetchGetJSON(url));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (dataFields) {
                  Curry._1(setState, (function (state) {
                          return {
                                  campaignDataFields: dataFields,
                                  deletedCampaignDataFields: state.deletedCampaignDataFields
                                };
                        }));
                  return Promise.resolve();
                }), fetchCampaignDataFields());
        }), []);
  var saveCampaignDataFields = function (param) {
    var encode = Belt_List.toArray(List.append(Belt_List.map(state.campaignDataFields, (function (x) {
                    return CampaignsDataField$ReactHooksTemplate.encode(undefined, x);
                  })), Belt_List.map(state.deletedCampaignDataFields, (function (x) {
                    return CampaignsDataField$ReactHooksTemplate.encode(true, x);
                  }))));
    var params = Json_encode.object_({
          hd: [
            "campaign",
            Json_encode.object_({
                  hd: [
                    "campaigns_data_field_attributes",
                    encode
                  ],
                  tl: /* [] */0
                })
          ],
          tl: /* [] */0
        });
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", Json_decode.string, response);
            if (status === "success") {
              Js_promise.then_((function (dataFields) {
                      Curry._1(setState, (function (param) {
                              return {
                                      campaignDataFields: dataFields,
                                      deletedCampaignDataFields: /* [] */0
                                    };
                            }));
                      return Promise.resolve();
                    }), fetchCampaignDataFields());
            } else {
              console.log("Failed to save campaign data fields");
            }
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/campaigns/" + campaignId + "/campaign_data_fields/bulk_update", params));
  };
  var updateCampaignDataFields = function (newDataFields) {
    Curry._1(setState, (function (state) {
            return {
                    campaignDataFields: newDataFields,
                    deletedCampaignDataFields: state.deletedCampaignDataFields
                  };
          }));
  };
  var deleteCampaignDataField = function (dataField) {
    Curry._1(setState, (function (state) {
            return {
                    campaignDataFields: Belt_List.keep(state.campaignDataFields, (function (f) {
                            return Caml_obj.notequal(f, dataField);
                          })),
                    deletedCampaignDataFields: Belt_List.concat({
                          hd: dataField,
                          tl: /* [] */0
                        }, state.deletedCampaignDataFields)
                  };
          }));
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(CampaignDataFieldsForm$ReactHooksTemplate.make, {
                    campaignDataFields: state.campaignDataFields,
                    updateCampaignDataFields: updateCampaignDataFields,
                    deleteCampaignDataField: deleteCampaignDataField,
                    saveCampaignDataFields: saveCampaignDataFields
                  }),
              className: "p-8"
            });
}

var make = CampaignDataFieldPage;

exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
